export enum ToothColors {
  A1 = 0, A2 = 1, A3 = 2, A4 = 3,
  B1 = 4, B2 = 5, B3 = 6, B4 = 7,
  C1 = 8, C2 = 9, C3 = 10, C4 = 11,
  D1 = 12, D2 = 13, D3 = 14, D4 = 15,
  Bleach1 = 16, Bleach2 = 17, Bleach3 = 18, Bleach4 = 19
}
